import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Constants from "../../utils/constants";
import apiClient from "../../services/apiClient";
import toast from "../../utils/toast";
import { getLocalData, setLocalData } from "../../services/storageManager";

const initialState = {
    employeeList: [],
    loading: false,
    error: null,
    selectedEmp: false
}

export const getAllEmployees = createAsyncThunk(
    'getEmps',
    async (data, thunkAPI) => {
        const selectedDeptId=JSON.parse(getLocalData('selectedDept') || '{id:""}').id;
        return await apiClient({
            url: Constants.API.BASE_URL+Constants.API.DEPARTMENT.GET_ALL+'/'+selectedDeptId+'/'+Constants.API.EMPLOYEE.GET_ALL,
            method: 'GET'
        }, true)
            .then((data) => data.data)
            .catch((error) => {
                return thunkAPI.rejectWithValue(error)
            })
    }
)

const employeesSlice = createSlice({
    name: 'employees',
    initialState,
    reducers: {
        clearError(state, action) {
            state.error = null;
        },
        setCurrentEmployeeData(state, action) {
            state.selectedEmp = action.payload;
            setLocalData('selectedEmp', JSON.stringify(action.payload));
        }
    },
    extraReducers: (builder) => {
        /**Action--->get departments */
        builder
            .addCase(getAllEmployees.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getAllEmployees.fulfilled, (state, action) => {
                state.error = null;
                state.loading = false;
                state.employeeList = action.payload;
            })
            .addCase(getAllEmployees.rejected, (state, action) => {
                state.loading = false;
                toast.error(Constants.ERROR_MESSAGES.ERR_NETWORK);
            })
    }
})

export const { clearError, setCurrentEmployeeData } = employeesSlice.actions;
export const getLoading = (state) => state.employees.loading;
export const getError = (state) => state.employees.error;
export const getEmployees = (state) => state.employees.employeeList || [];
export const getSelectedEmployee = (state) => state?.employees?.selectedEmp || JSON.parse(getLocalData('selectedEmp') || '{}');

export default employeesSlice.reducer;